import $ from 'jquery';
import intersection from 'lodash-es/intersection';
import difference from 'lodash-es/difference';
import pickBy from 'lodash-es/pickBy';
import keys from 'lodash-es/keys';
import pull from 'lodash-es/pull';

import setUpScrollIndicator from '@/scripts/components/scrollIndicator';

export default class Filter {
  constructor() {

    this.selectors = {
      tagsJson: '[data-product-json]',
      filterTags: '[data-tag-member]',
    };

    this.classes = {
      selectedClass: 'selected',
      active: 'active',
      unselectableClass: 'unselectable'
    }

    this.products = [];
    this.allTags = [];
    this.selectedTags = [];

    this.init();
  }

  setUpProducts() {
    let context = this;
    $(this.selectors.tagsJson).each(function () {
      let productSingleObject = JSON.parse(
        $(this).html(),
      );
      context.products[productSingleObject.handle] = {};
      context.products[productSingleObject.handle].tags = productSingleObject.tags;
      context.products[productSingleObject.handle].isSelected = true;
      context.products[productSingleObject.handle].element = $("[data-title-" + productSingleObject.handle + "]");
    });
  }

  setUpFilter() {
    let context = this;
    for (var key in this.products) {
      this.products[key].tags.forEach((tag) => {
        if (!context.allTags.includes(tag)) {
          context.allTags.push(tag);
        }
      });
    }
  }

  setUpListeners() {
    let context = this;
    $(this.selectors.filterTags).click(function (event) {
      context.processClick($(event.target));
    });
  }

  processClick($target) {
    if ($target.hasClass(this.classes.unselectableClass)) {
      return;
    }
    if ($target.hasClass(this.classes.selectedClass)) {
      $target.removeClass(this.classes.selectedClass);
      this.deselectTag($target.data('tag'));
    }
    else {
      $target.addClass(this.classes.selectedClass);
      this.selectTag($target.data('tag'))
    }
    this.updateTags();
  }

  selectTag(tag) {
    this.selectedTags.push(tag);
    this.updateProducts(tag, "add");
  }

  deselectTag(tag) {
    pull(this.selectedTags, tag);
    this.updateProducts(tag, "remove");
  }

  updateProducts(tag, action) {
    if (this.selectedTags.length == 0) {
      for (var key in this.products) {
        if (this.products[key].element) {
          this.products[key].element.addClass(this.classes.active);
        }
        this.products[key].isSelected = true;
      }
    }
    else {
      for (var key in this.products) {
        if (intersection(this.products[key].tags, this.selectedTags).length == this.selectedTags.length) {
          if (this.products[key].element) {
            this.products[key].element.addClass(this.classes.active);
          }
          this.products[key].isSelected = true;
        }
        else {
          if (this.products[key].element) {
            this.products[key].element.removeClass(this.classes.active);
          }
          this.products[key].isSelected = false;
        }
      }
    }
    let numSelected = keys(pickBy(this.products, ['isSelected', true]));
    $('#selected-fragrances').html(numSelected.length);

    //KEEPING IN JQUERY TO SAVE TIME AND FOLLOW PATH FROM HANDOFF

    if (numSelected.length < 5) {
      if ($('.home__filter__count-phrase').length !== 0) {
        $('.home__filter__count-phrase').html('We recommend');
      }
      if ($('.home__filter__count-clear').length !== 0) {
        $('.home__filter__count-clear').addClass('active');
      }
    } else if (numSelected.length === 5) {
      if ($('.home__filter__count-phrase').length !== 0) {
        $('.home__filter__count-phrase').html('Find your match');
      }
      if ($('.home__filter__count-clear').length !== 0) {
        $('.home__filter__count-clear').removeClass('active');
      }
    }

    $('.home__filter__count-clear').click(function () {
      if ($('.selector__container li.selected').length !== 0) {
        $('.selector__container li.selected').trigger('click');
      }
    });
  }

  updateTags() {
    let remainingTags = difference(this.allTags, this.selectedTags);
    let selectedProducts = pickBy(this.products, ['isSelected', true]);
    remainingTags.forEach((tag) => {
      let remainingSelectableProducts = false;
      for (const product in selectedProducts) {
        if (this.products[product].tags.includes(tag)) {
          remainingSelectableProducts = true;
          break;
        }
      }
      if (remainingSelectableProducts == true) {
        if ($('*[data-tag="' + tag + '"]').length !== 0) {
          $('*[data-tag="' + tag + '"]').removeClass(this.classes.unselectableClass);
        }
      }
      else {
        if ($('*[data-tag="' + tag + '"]').length !== 0) {
          $('*[data-tag="' + tag + '"]').addClass(this.classes.unselectableClass);
        }
      }
    });
  }

  init() {
    if (!$(this.selectors.tagsJson).html()) {
      return;
    }

    this.setUpProducts();
    this.setUpFilter();
    this.setUpListeners();
    setUpScrollIndicator('.selector');
  }
}
